import { Box, IconButton, MenuItem, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import React, { Suspense, lazy, useContext, useState } from "react";
import { LoadingScreen } from "src/components/ui";
import PrimaryHoverEffect from "src/components/ui/warehouse/primaryHoverEffect";
import { ProMenuBox } from "./style";

import { MenuContext } from "src/contexts/menu-context/MenuContext";

const ProfessionalItem = ({ menu }) => {
  const theme = useTheme();
  const [anchorChainMenuEl, setAnchorChainMenuEl] = useState(null);
  const { addToNewTab, setTab } = useContext(MenuContext);
  const openChainMenu = Boolean(anchorChainMenuEl);

  const handleChainMenuClick = (event) => {
    setAnchorChainMenuEl(event.currentTarget);
  };

  const handleChainMenuClose = () => setAnchorChainMenuEl(null);

  let Icon;

  const handleMenuItemClick = (menuItem) => {
    if (menuItem.content) {
      addToNewTab(menuItem);
      setTab(menuItem.id);
    }
  };

  if (menu?.length !== 0)
    return (
      <>       
        <Stack spacing={1.5} justifyItems="center" alignItems="center" key={menu.node.id}>
          <Suspense>
            {(Icon = lazy(() => import("src/components/ui/svgIcon/" + menu?.node?.icon)))}
            <Tooltip title={menu.node.menuName} arrow followCursor>
              <Box height={35}>
                <PrimaryHoverEffect className={openChainMenu ? "active" : ""}>
                  <IconButton onClick={handleChainMenuClick}>
                    <Icon color={theme.palette.primary.main} fontSize="small" />
                  </IconButton>
                </PrimaryHoverEffect>
              </Box>
            </Tooltip>
          </Suspense>
        </Stack>

        <ProMenuBox anchorEl={anchorChainMenuEl} open={openChainMenu} onClose={handleChainMenuClose}>
          {menu?.node?.subMenus?.edges.map((subMenuItem) => (
            <Box key={subMenuItem.node.id}>
              <MenuItem
                onClick={() => {
                  handleMenuItemClick({
                    val: subMenuItem.node.name,
                    id: subMenuItem.node.id,
                    loading: false,
                    content: subMenuItem.node.codeInWeb
                      ? lazy(() => import("src/features/" + subMenuItem.node.codeInWeb))
                      : null,
                      props: {
                          subMenuID: subMenuItem.node.id,
                          educationalGuidance: subMenuItem.node.educationalGuidance,
                        },
                  });
                  handleChainMenuClose();
                }}
                className={menu.openCo ? "active" : ""}
                sx={{ fontWeight: "fontWeightMedium" }}
              >
                <Stack direction="row" justifyContent="space-between" width="100%" alignItems="center">
                  <Box mr="auto">
                    <Typography variant="body2">{subMenuItem.node.name}</Typography>
                  </Box>
                </Stack>
              </MenuItem>
            </Box>
          ))}

          {/* <ProPopUpSection menu={menu?.node?.subMenus} handleClose={handleChainMenuClose} /> */}
        </ProMenuBox>
      </>
    );
};

export default ProfessionalItem;
